var map = {
	"./courseCover.png": 401,
	"./cover-placeholder.png": 402,
	"./error-image.png": 403,
	"./heart.svg": 404,
	"./lemon.svg": 405,
	"./sad_turtle.png": 406,
	"./timun_logo.png": 407,
	"./video-placeholder.png": 408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 400;